<template>
  <tr
    v-if="!showIfBookmarked || (showIfBookmarked && isBookmarked)"
    class="md:border-b-2"
    :class="{ '!bg-yellow-200': isOutbid }"
    :style="{ 'background-color': productToColor(productMap[lot.productUuid].code)}"
  >
    <td>
      <BookmarkIcon
        :lot="lot"
        :is-bookmarked="isBookmarked"
        @added="isBookmarked = true"
        @removed="isBookmarked = false"
      />
    </td>
    <td class="text-center font-bold">
      {{ productMap[lot.productUuid].code }} - {{ JSON.parse(productMap[lot.productUuid].multilangName)[$i18n.locale] }}
    </td>
    <td class="text-center">
      {{ lot.quantity }} t
    </td>
    <td class="text-center">
      {{ lot.price }} €/t
    </td>

    <td
      v-if="auction.auctionStatus == 'REDISTRIBUTING_1' || auction.auctionStatus == 'REDISTRIBUTING_2'"
      class="text-center hidden md:table-cell"
    >
      <PreemptButton
        v-if="authStore.canBid && myLot?.canSelect"
        :auction="auction"
        :lot="lot"
        :my-lot="myLot"
        @click.prevent="preemptingLot = lot"
      />
      
      <a
        v-else-if="auction?.me?.lotRedistributes[lot.uuid].winner"
        class="btn btn-preemption-winner"
      >
        {{ $t("lot.preempted") }}
      </a>
    </td>

    <td
      v-if="auction.auctionStatus == 'CLOSED'"
      class="text-center hidden md:table-cell"
    >
      <a
        v-if="auction?.me?.lotRedistributes[lot.uuid].winner"
        class="btn btn-preemption-winner"
      >
        {{ $t("lot.preempted") }}
      </a>
    </td>
  </tr>

  <tr
    class="md:hidden border-b-2"
    :class="{ '!bg-yellow-200': isOutbid }"
    :style="{ 'background-color': productToColor(productMap[lot.productUuid].code)}"
  >
    <td
      colspan="100"
      class="pb-4"
    >
      <div
        v-if="auction.auctionStatus == 'REDISTRIBUTING_1' || auction.auctionStatus == 'REDISTRIBUTING_1'"
        class="flex"
      >
        <div class="flex-grow" />
        <div>
          <PreemptButton
            v-if="authStore.canBid && myLot?.canSelect"
            :auction="auction"
            :lot="lot"
            :my-lot="myLot"
            @click.prevent="preemptingLot = lot"
          />
          <a
            v-else-if="auction?.me?.lotRedistributes[lot.uuid].winner"
            class="btn btn-preemption-winner"
          >
            {{ $t("lot.preempted") }}
          </a>
        </div>
      </div>

      <div
        v-else-if="auction.auctionStatus == 'CLOSED'"
        class="flex"
      >
        <div class="flex-grow" />
        <div>
          <a
            v-if="auction?.me?.lotRedistributes[lot.uuid].winner"
            class="btn btn-preemption-winner"
          >
            {{ $t("lot.preempted") }}
          </a>
        </div>
      </div>
    </td>
  </tr>

  <PreemptModal 
    v-if="preemptingLot"
    :auction="auction"
    :lot="preemptingLot"
    :product-map="productMap"
    @close="preemptingLot = null"
    @update-auction="$emit('update-auction', $event)"
  />
</template>

<script setup>
import { ref } from 'vue'

import BookmarkIcon from '@/components/lot/BookmarkIcon.vue';
import lotBookmark from '@/services/lot-bookmarks';
import productToColor from '@/services/product-to-color';
import { useAuthStore } from '@/stores/auth';

import PreemptButton from './PreemptButton.vue';
import PreemptModal from './PreemptModal.vue';

const emit = defineEmits(['update-auction'])

const props = defineProps({
    auction: {
        type: Object,
        required: true
    },
    lot: {
        type: Object,
        required: true
    },
    myLot: {
        type: Object,
        required: false,
        default: null
    },
    productMap: {
        type: Object,
        required: true
    },
    showIfBookmarked: {
        type: Boolean,
        required: true
    },
    isOutbid: {
        type: Boolean,
        required: false
    }
})

const authStore = useAuthStore();

const isBookmarked = ref(lotBookmark.isBookmarked(props.lot.uuid));

const preemptingLot = ref(null)
</script>